import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserI} from './pages/admin/interfaces/user.interface';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'sso-admin';
  public authed = false;
  public user: UserI;

  constructor(
    public app: AuthService,
    public router: Router
  ) {

  }

  public ngOnInit(): void {
    this.app.isAuthed((auth: boolean) => {
      this.authed = auth;
      this.user = this.app.user;
    });
  }
}
